import { type RouteRecordRaw } from 'vue-router';
import { Layout } from '@/core/layout/layout';

export default {
    path: '/document/:accountId/create/:documentId',
    component: () => import('../views/Client/ClientDocumentCreateView.vue'),
    name: 'document-create',
    meta: {
        private: true,
        layout: Layout.HeaderOnly,
    },
} as RouteRecordRaw;
